export const decrement = (prev, packageQty = 1) => {
  const remainder = prev % packageQty;
  let newValue;
  if (remainder > 0) {
    newValue = prev - remainder;
  } else {
    newValue = prev - packageQty;
  }
  return newValue > packageQty ? newValue : packageQty;
};

export const increment = (prev, packageQty = 1, maximum = 99999) => {
  const remainder = prev % packageQty;
  let newValue = prev - remainder + packageQty;
  if (newValue > maximum) {
    newValue = maximum;
  }
  return newValue < packageQty ? packageQty : newValue;
};
